export enum configNames {
  apiConfig = 'apiConfig',
  csplusConfig = 'csplusConfig',
  ssoConfig = 'ssoConfig'
}
